module.exports = __webpack_public_path__ + "img/LoginPage_Graphic.6a140fc7.png";